import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What types of hybrid vehicles exist?",
    category: "Technology",
    description:
      "There are three main types: mild hybrids that assist the engine, full hybrids that run on electric or engine power, and plug-in hybrids that use larger batteries and can be charged externally.",
  },
  {
    title: "What are the benefits of driving an HEV?",
    category: "Trending",
    description:
      "HEVs offer better fuel economy, lower emissions, reduced running costs, smoother driving, and government incentives. They combine electric efficiency with the long driving range of traditional fuel engines.",
  },
  {
    title: "Are HEVs expensive to maintain?",
    category: "Design",
    description:
      "HEVs generally have maintenance costs similar to conventional cars. Regenerative braking reduces wear on brakes, and the electric motor lowers engine strain, often resulting in fewer mechanical issues over time.",
  },
  {
    title: "What will I learn in an HEV engineering course?",
    category: "Design",
    description:
      "You will study hybrid powertrains, battery systems, electric motors, control units, regenerative braking, energy management, diagnostics, and maintenance. Practical labs help you understand real-world HEV functioning and technology.",
  },
  {
    title: "Are HEVs cheaper to operate than normal cars?",
    category: "Design",
    description:
      "Yes, HEVs use less fuel, require fewer brake replacements, and experience less engine wear. These factors significantly reduce running costs, making hybrids more economical over time.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
